export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--5-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/lib/index.js??ref--5-3!../../../../node_modules/sass-loader/dist/cjs.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=bbc0b1d0&prod&lang=scss&rel=stylesheet%2Fscss&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/index.vue?vue&type=style&index=0&id=bbc0b1d0&prod&lang=scss&rel=stylesheet%2Fscss&
// module id = 538
// module chunks = 30